import ApiClient from 'dashboard/api/ApiClient';

class HobbyAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  getUser(contactId) {
    return axios.get(`${this.baseUrl()}/contacts/${contactId}/hobby`);
  }

  addSubscription(contactId, months) {
    return axios.post(`${this.baseUrl()}/contacts/${contactId}/hobby/subscription`, { months });
  }

  adjustSubscription(contactId, days) {
    return axios.post(`${this.baseUrl()}/contacts/${contactId}/hobby/days`, { days });
  }

  cancelSubscription(contactId) {
    return axios.delete(`${this.baseUrl()}/contacts/${contactId}/hobby/subscription`);
  }

  toggleAutoRenew(contactId) {
    return axios.post(`${this.baseUrl()}/contacts/${contactId}/hobby/auto_renew`);
  }
}

export default new HobbyAPI();
